module.exports = __webpack_public_path__ + "img/empty.0cec218a.svg";